import { render, staticRenderFns } from "./editPripTaal.vue?vue&type=template&id=345aea5a&scoped=true"
import script from "./editPripTaal.vue?vue&type=script&lang=js"
export * from "./editPripTaal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345aea5a",
  null
  
)

export default component.exports